import { render, staticRenderFns } from "./ExpedienteCoplacaParcelasActionsCellRenderer.vue?vue&type=template&id=75823b60"
import script from "./ExpedienteCoplacaParcelasActionsCellRenderer.vue?vue&type=script&lang=js"
export * from "./ExpedienteCoplacaParcelasActionsCellRenderer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports